<template>
    <div id="pagenation" class="row justify-content-center">
        <div class="col-auto">
            <ul v-if="pagenation.total>pagenation.pageSize" class="pagination ">
                <li class="page-item">
                    <a href="javascript:void(0);" @click="startPage" class="page-link">首页</a>
                </li>
                <li v-for="i in displayPage"
                    :key="'pagenation_'+i" :class="pagenationItemActive(i)">
                    <a href="#" @click="selectPage(i)" class="page-link">{{i}}</a>
                </li>
                <li class="page-item ">
                    <a href="javascript:void(0);" @click="endPage" class="page-link">尾页</a>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Pagenation",
         props:['type'],
        data() {
            return {
                newsType:'',
                pagenation: {
                    total: 0,//总共多少条
                    pageSize: 10,//一页展示几条
                    pageNum: 1,//第几页
                },

            }
        },
        mounted() {
          this.getTotal();

        },
        computed: {
            displayPage() {
                console.log(this.pagenation.total)
                let totalPage = this.pagenation.total % this.pagenation.pageSize === 0 ? (parseInt(this.pagenation.total / this.pagenation.pageSize)) : (parseInt(this.pagenation.total / this.pagenation.pageSize) + 1)
                console.log(totalPage)
                let pageNum = this.pagenation.pageNum;
                if (totalPage < 10) {
                    return totalPage;
                } else {
                    let arr = []
                    if (pageNum < 5) {
                        for (let i = 1; i <= 10; i++) {
                            arr.push(i)
                        }
                    } else if (pageNum >= totalPage - 5) {
                        for (let i = totalPage - 9; i <= totalPage; i++) {
                            arr.push(i)
                        }
                    } else {
                        for (let i = pageNum - 4; i <= pageNum + 5 && i < totalPage; i++) {
                            arr.push(i)
                        }
                    }
                    return arr
                }
            }
        },
        watch: {
            'pagenation.pageNum'(newValue, oldValue) {
                console.log(newValue, oldValue)
                this.getTotal()
            },
        },
        methods: {
          getTotal(){
            this.newsType=this.type;
            console.log(111)
             // this.pageNumChange();
             this.$axios({
                         method: 'get',
                         url: this.HOST+'/wd/journalism/typeList?page='+this.pagenation.pageNum+'&size='+this.pagenation.pageSize+'&type='+this.newsType,
                         data: {
                             page:this.pagenation.pageNum,
                             size:this.pagenation.pageSize,
                             type:this.newsType,
                         }
                       }).then(res =>{
                         console.log(res)
                         if(res.data.total==null){
                           console.log(res)
                           this.$emit("getnews",res.data.list);
                           this.pagenation.total=40
                         }else{
                           this.$emit("getnews",res.data.list);
                           this.pagenation.total=res.data.total;
                         }

                       })
          },
          pageNumChange(newPageNum, oldPageNum){
          //可以传入两个参数，newPageNum：新的页码，oldPageNum：之前的页码

            console.log("pageNumChange",newPageNum, oldPageNum)
            // this.$axios({
            //             method: 'post',
            //             url: 'www.baidu.com',
            //             data: {
            //               pageNum:this.pagenation.pageNum,
            //               pageSize:this.pagenation.pageSize
            //             }
            //           }).then(function (resp){
            //             this.pagenation.total=resp.total;
            //              //return resp.data;
            //              }
            //       )
          },

            pagenationItemActive(i) {
                if (i == this.pagenation.pageNum) {
                    return 'page-item active'
                } else {
                    return 'page-item'
                }
            },
            selectPage(pageNum) {
                this.pagenation.pageNum = pageNum

            },
            startPage() {
                if (this.pagenation.pageNum !== 1) {
                    this.pagenation.pageNum = 1
                }
            },
            endPage() {
                let totalPage = this.pagenation.total % this.pagenation.pageSize === 0 ? (parseInt(this.pagenation.total / this.pagenation.pageSize)) : (parseInt(this.pagenation.total / this.pagenation.pageSize) + 1)
                if (this.pagenation.pageNum !== totalPage) {
                    this.pagenation.pageNum = totalPage
                }
            }

        }
    }
</script>

<style >

</style>



// WEBPACK FOOTER //
// src/components/public/Pagenation.vue